import { Col, Row, Collapse } from 'antd';
import React from 'react';

import './style.less';

const { Panel } = Collapse;

const renderRow = (item) => {
  return (
    <Row>
      <Col span={12} className="description">
        <strong>{item?.title ?? '-'}</strong>
      </Col>
      <Col span={12} className="details">
        <span>{item?.content ?? '-'}</span>
      </Col>
    </Row>
  );
};

const renderHeader = (header, columns) => {
  return (
    <Row className="header-panel">
      {columns.map((column) => (
        <Col span={column.span}>
          <span className="title">
            {!Array.isArray(header[column.prop])
              ? header[column.prop]
              : header[column.prop]?.map((element) => (
                  <>
                    <span className="identifier-style">{element}</span> <br />
                  </>
                ))}
          </span>
        </Col>
      ))}
    </Row>
  );
};

const CollapseList = ({
  columns = [],
  list = [],
  index = '',
  collapsePrintSuffix = '',
  collapseOpened = false,
}) => {
  return (
    <div className="KYB-collapse-list">
      <Row className="columns">
        {columns?.map((element) => (
          <Col span={element?.span}>
            <strong>{element?.title}</strong>
          </Col>
        ))}
      </Row>

      {list?.map((item) => {
        const halfLength = Math.ceil(item?.body?.length / 2);
        const leftSide = item?.body?.slice(0, halfLength);
        const rightSide = item?.body?.slice(halfLength, item?.body?.length);
        const collapseKey = item?.header?.id + collapsePrintSuffix + index;
        const collapseProps = {
          activeKey: collapseKey,
        };
        const props = collapseOpened && collapseKey ? collapseProps : {};

        return (
          <Collapse className="mrg-top-10" {...props}>
            <Panel header={renderHeader(item?.header, columns)} key={collapseKey}>
              <Row className="wrapper-content">
                <Col span={12}>
                  {leftSide?.map((item) => {
                    return renderRow(item);
                  })}
                </Col>
                <Col span={12}>
                  {rightSide?.map((item) => {
                    return renderRow(item);
                  })}
                </Col>
              </Row>
            </Panel>
          </Collapse>
        );
      })}
    </div>
  );
};

export default CollapseList;
